module.exports = __webpack_public_path__ + "static/media/signage-industrial-img14.248ec3a6.jpg";